function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import { Close } from '../../../../Close';
import { TextInput } from '../TextInput';
import Search from '@dtsl/icons/dist/icons/react/Search';

// eslint-disable-next-line react/display-name
const SearchInput = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    actions = [],
    disabled = false,
    readOnly = false
  } = props;
  const searchActions = [() => /*#__PURE__*/React.createElement(Close, _extends({}, actions[0], {
    size: "small"
  }))];
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    prefix: () => /*#__PURE__*/React.createElement(Search, {
      "aria-hidden": "true"
    }),
    suffix: null,
    actions: searchActions,
    maxCharCount: null,
    ref: ref,
    readOnly: readOnly,
    disabled: disabled
  }));
});
SearchInput.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool
};
export default /*#__PURE__*/memo(SearchInput);